import {URL} from '@acng/frontend-bounty/net/url.js';
import {GlobalActor, GlobalContext, globalValue} from '@acng/frontend-relativity';

/**
 * @returns {URLSearchParams}
 */
const getSearchParams = () => new URL(location.hash.substring(1), location.origin).searchParams;

export const ctxSearchParams = GlobalContext(getSearchParams());

export const update = (() => {
  const update_ = GlobalActor(ctxSearchParams);

  return () => {
    const params = getSearchParams();
    const previous = globalValue(ctxSearchParams);

    if (params.size != previous.size) {
      update_(params);
    } else
      for (const [key, value] of params) {
        if (value != previous.get(key)) {
          update_(params);
          break;
        }
      }
  };
})();
